import { animateScroll } from 'react-scroll';
import { LOCATION_CHANGED } from 'redux-little-router';
import { takeLatest } from 'redux-saga/effects';
import { PROFILE_TABS } from 'modules/Profile/components/ProfilePage/constants';

export default function* propertyObjectTypesSaga() {
  yield takeLatest(LOCATION_CHANGED, scrollToTop);
}

function scrollToTop(action) {
  if (isProfileTabs(action.payload)) {
    return;
  }
  animateScroll.scrollToTop({
    duration: 0,
    containerId: '#scroll-wrapper',
  });
}

function isProfileTabs(payload = {}) {
  const { route } = payload;
  return PROFILE_TABS.some((tab) => tab.tabRoute === route);
}
